/**
 * Coffee Bean Clicker v2 - Theme & Layout Constants
 */

export const THEME = {
  bg: {
    dark: 0x1A0E08,
    medium: 0x2A1810,
    light: 0x3D2517,
    panel: 0x140B06,
    glass: 0x1A0E08,
    glassAlpha: 0.75,
    cardAlpha: 0.75,
  },
  accent: {
    gold: 0xD4AF37,
    green: 0x8BC34A,
    lightGreen: 0xA5D6A7,
    cream: 0xF5E6D3,
    brown: 0x8B5A3C,
    dimBrown: 0x6D4C41,
    orange: 0xFF8F00,
    red: 0xE53935,
    cherry: 0xD32F2F,
    blue: 0x42A5F5,
    purple: 0xAB47BC,
    white: 0xFFFFFF,
    dimWhite: 0xBBAAAA,
  },
  button: {
    primary: 0x8BC34A,
    primaryHover: 0x9CCC65,
    disabled: 0x444444,
    prestige: 0xD4AF37,
    star: 0xAB47BC,
    danger: 0xC62828,
    boost: 0xFF8F00,
  },
  border: {
    glass: 0xFFFFFF,
    glassAlpha: 0.06,
    gold: 0xD4AF37,
    goldAlpha: 0.3,
  },
  text: {
    primary: 0xF5E6D3,
    secondary: 0xBBAAAA,
    gold: 0xD4AF37,
    green: 0x8BC34A,
    white: 0xFFFFFF,
    crit: 0xFFD700,
    combo: 0xFF6B35,
  },
  font: {
    family: 'system-ui, -apple-system, sans-serif',
  },
} as const;

export const LAYOUT = {
  topBarH: 72,
  tabBarH: 60,
  boostBarH: 40,
  padding: 12,
  gap: 8,
  rowH: 68,
  cardRadius: 14,
  btnRadius: 20,
  iconSize: 44,
  safeTop: 0,
  safeBottom: 0,
} as const;
